<template>
    <div>
        <v-list-tile-title v-if="'AGUARDANDO_REENVIO' === documento.situacao" style="user-select: none">
            Reenvio Solicitado, por favor, aguarde...
        </v-list-tile-title>

      <v-list-tile-title v-else-if="'AGUARDANDO_ENVIO' === documento.situacao ||
                          'ENVIADO_TEMPORARIO' === documento.situacao" style="user-select: none">
        Envio Solicitado, por favor, aguarde...
      </v-list-tile-title>

      <v-dialog v-else v-model="mostrarDialogoConfirmacaoReenvio" persistent max-width="800">
        <v-list-tile-title class="solicitar-reenvio-ativador" slot="activator">
          Solicitar Reenvio
        </v-list-tile-title>

        <v-card>
          <v-card-title class="primary modal-title" primary-title>
           Motivo Solicitação de Reenvio
          </v-card-title>
            <v-card-text>
                <v-layout class="d-flex">
                    <v-flex xs12>
                        <label><strong>Documento</strong></label>
                        <p class="text--secondary"  v-html="documento.descricao"></p>
                    </v-flex>
                    <v-flex xs12>
                        <label><strong>Participante</strong></label>
                        <p class="text--secondary"  v-html="documento.nomeFornecedor"></p>
                    </v-flex>
                </v-layout>
            </v-card-text>
          <v-card-text class="pb-0 az-form-content">
                <v-textarea v-model="documento.motivoReenvio"
                            :error-messages="errors.collect('Motivo')"
                            v-validate="mostrarDialogoConfirmacaoReenvio? 'required' : ''"
                            :name="'Motivo'"
                            label="Motivo Reenvio"
                            placeholder="Digite aqui o motivo"
                            rows="7"
                            maxlength="1000"
                            :counter="1000"
                            class="required-field"
                            :disabled="!isEdicao || situacaoSolicitacaoCredenciamento !== 'AGUARDANDO_ANALISE'"/>
            </v-card-text>
            <v-card-actions class="acoes justify-space-between">
                <v-btn class="ml-3" color="#777" flat @click="mostrarDialogoConfirmacaoReenvio = false">
                  {{ isEdicao && situacaoSolicitacaoCredenciamento === 'AGUARDANDO_ANALISE' ? 'Cancelar' : 'Voltar' }}
                </v-btn>
                <v-btn v-if="isEdicao && situacaoSolicitacaoCredenciamento === 'AGUARDANDO_ANALISE'"
                    class="botao-primario confirmar mr-3" @click="confirmarSolicitacao">
                  Salvar
                </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
import {mapState} from "vuex";
import {mutationTypes} from "@/commons/constants";

export default {
    name: 'AcoesSolicitarReenvioDocumento',
    props: {
      situacaoSolicitacaoCredenciamento: {
        type: String,
        required: true
      },
      documento: {
        type: Object,
        required: true
      }
    },
    data() {
        return {
            mostrarDialogoConfirmacaoReenvio: false
        }
    },
    computed: {
      ...mapState(['mostrarModalConfirmacaoReenvioDocumentoSoliciacaoCredenciamento']),
      isEdicao() {
        return !!this.$route.query.edicao
      },
    },
    methods: {
        fecharDialogoConfirmacaoReenvio(){
            this.mostrarDialogoConfirmacaoReenvio = false
        },
        async confirmarSolicitacao(){
            await this.validarCampos()
            this.fecharDialogoConfirmacaoReenvio()
            this.$emit('confirmarSolicitacao')
        },
        async validarCampos(){
            const estaValidado = await this.$validator.validateAll()
            if(!estaValidado){
                throw new Error('Preencha o campo Motivo obrigatório.')
            }
        }
    },
    watch: {
      mostrarModalConfirmacaoReenvioDocumentoSoliciacaoCredenciamento(novoValor){
        this.mostrarDialogoConfirmacaoReenvio = novoValor
      },
      mostrarDialogoConfirmacaoReenvio(novoValor){
        this.$store.commit(mutationTypes.CREDENCIAMENTO.SET_MOSTRAR_MODAL_MOTIVO_REENVIO_DOCUMENTO, novoValor)
      }
    }
}
</script>

<style scoped lang="stylus">
    .modal-title
        justify-content space-between

        .v-btn
          padding 0
          margin 0
          color #fff
          box-sizing border-box
          min-width 25px

    .botao-primario
      padding 0 25px
      border 1px solid #0067a5
      background-color #0067a5 !important
      color #fff !important
      box-sizing border-box
      margin-left 15px !important

    .acoes
      padding 20px 0 !important

    .solicitar-reenvio-ativador
      transition all 0.3s ease
      color var(--v-primary-base)
      padding 0px 20px

      &:hover
        background-color #f9f9f9

</style>